/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CustomerInvoiceType {
  ShipmentCharge = "shipment_charge",
  AdditionalCharge = "additional_charge",
  ShipmentRefund = "shipment_refund",
  AdditionalChargeRefund = "additional_charge_refund",
}

export function instanceOfCustomerInvoiceType(value: any): boolean {
  for (const key in CustomerInvoiceType) {
    if (Object.prototype.hasOwnProperty.call(CustomerInvoiceType, key)) {
      if (
        CustomerInvoiceType[key as keyof typeof CustomerInvoiceType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomerInvoiceTypeFromJSON(json: any): CustomerInvoiceType {
  return CustomerInvoiceTypeFromJSONTyped(json, false);
}

export function CustomerInvoiceTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerInvoiceType {
  return json as CustomerInvoiceType;
}

export function CustomerInvoiceTypeToJSON(
  value?: CustomerInvoiceType | null,
): any {
  return value as any;
}

export function CustomerInvoiceTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CustomerInvoiceType {
  return value as CustomerInvoiceType;
}
